import { createWebHistory, createRouter } from "vue-router";
import type { RouteLocationGeneric, RouteRecordRaw } from "vue-router";
import MainPage from "@/views/MainPage.vue";
import Login from "@/views/LoginPage.vue";
import Analytics from "@/Analytics.vue";
import AngularEmbedPage from "@/views/AngularEmbedPage.vue";
import { rootStore } from "@/store/index";
import { AnalyticsV2ElementType } from "@/models/etc/types";
import { loadSession, applySession } from "@/composables/useSession";

const routes: RouteRecordRaw[] = [
    {
        path: "/main",
        name: "Main",
        component: MainPage,
    },
    {
        path: "/analytics",
        name: "Analytics",
        component: Analytics,
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
    },
    {
        path: "/calendar",
        name: "Calendar",
        component: AngularEmbedPage,
        meta: { angularPath: "calendar" },
    },
    {
        path: "/settings",
        name: "Settings",
        component: AngularEmbedPage,
        meta: { angularPath: "settings" },
    },
    // Склад — сегмент «Позиции склада» в Аналитике.
    {
        path: "/storage",
        redirect: (to: RouteLocationGeneric) => ({
            path: "/analytics",
            query: { ...to.query, segment: String(AnalyticsV2ElementType.StorageItem) },
        }),
    },
    {
        path: "/project/:id(\\d+)",
        redirect: (to: RouteLocationGeneric) => ({
            path: "/main",
            query: { ...to.query, page: "project", id: String(to.params.id) },
        }),
    },
    {
        path: "/client/:id(\\d+)",
        redirect: (to: RouteLocationGeneric) => ({
            path: "/main",
            query: { ...to.query, page: "client", id: String(to.params.id) },
        }),
    },
    {
        path: "/",
        redirect: "/main",
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

const isSafeRedirect = (path: string): boolean =>
    typeof path === "string" && path.startsWith("/") && !path.startsWith("//") && path !== "/login";

router.beforeEach((to) => {
    const hasSession = !!rootStore().jwtToken || !!loadSession();

    if (to.path === "/login") {
        if (hasSession) {
            const redirect = String(to.query.redirect ?? "");
            return isSafeRedirect(redirect) ? redirect : "/main";
        }
        return true;
    }

    if (!hasSession) {
        return { path: "/login", query: { redirect: to.fullPath } };
    }

    if (!rootStore().jwtToken) {
        const session = loadSession();
        if (session) {
            applySession(session);
        }
    }

    return true;
});

export default router;
